module.exports = __webpack_public_path__ + "static/media/profile_64.78010f67.svg";